import { render, staticRenderFns } from "./UploadRecord.vue?vue&type=template&id=865625d2&scoped=true"
import script from "./UploadRecord.vue?vue&type=script&lang=js"
export * from "./UploadRecord.vue?vue&type=script&lang=js"
import style0 from "./UploadRecord.vue?vue&type=style&index=0&id=865625d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865625d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865625d2')) {
      api.createRecord('865625d2', component.options)
    } else {
      api.reload('865625d2', component.options)
    }
    module.hot.accept("./UploadRecord.vue?vue&type=template&id=865625d2&scoped=true", function () {
      api.rerender('865625d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/UploadRecord.vue"
export default component.exports